import { LocationType } from './types';

export const getNameLocations = (name: LocationType) => {
  switch (name) {
    case LocationType.VAO_LINA:
      return 'Vão Lina';
    case LocationType.LINA:
      return 'Lina';
    case LocationType.PIETRO:
      return 'Pietro';
    case LocationType.GUARDA_VOLUMES_LINA:
      return 'Guarda Volumes Lina';
    case LocationType.GUARDA_VOLUMES_PIETRO:
      return 'Guarda Volumes Pietro';
    case LocationType.LOJA_MASP:
      return 'Loja MASP';
    default:
      return 'Não catalogado. (Erro)';
  }
};
